(() => {
	const dingLogin = {
		config: null,
		configPromise: null,
		loginDebug: false,
		redirectTo: "/app",
		qrInitialized: false,
		qrInitPromise: null,
	};

	function t(text) {
		try {
			if (typeof window.__ === "function") return window.__(text);
			if (window.frappe && typeof window.frappe._ === "function") return window.frappe._(text);
		} catch (e) {
			// ignore
		}
		return text;
	}

	function isLoginPage() {
		try {
			if (window.location.pathname === "/login") return true;
			return Boolean(
				document.querySelector("section.for-login")
					|| document.querySelector("form.form-login")
					|| document.getElementById("login_email")
			);
		} catch (e) {
			return false;
		}
	}

	function getSearchParam(name) {
		try {
			if (window.URLSearchParams) {
				const params = new URLSearchParams(window.location.search || "");
				return params.get(name);
			}
		} catch (e) {
			// ignore
		}

		try {
			const q = String(window.location.search || "");
			const m = q.match(new RegExp(`[?&]${name.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\\\$&")}=([^&]*)`));
			return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null;
		} catch (e) {
			return null;
		}
	}

	function isTruthyParam(name) {
		const v = String(getSearchParam(name) || "").toLowerCase();
		return v === "1" || v === "true" || v === "yes";
	}

	function shouldShowLocalLogin() {
		return isTruthyParam("show_local");
	}

	function shouldHideOfficialLogin() {
		return Boolean(dingLogin.config?.hide_official_login) && !shouldShowLocalLogin();
	}

	function isWeChatUa() {
		try {
			return String(navigator.userAgent || "").toLowerCase().includes("micromessenger");
		} catch (e) {
			return false;
		}
	}

	function isMobileDevice() {
		try {
			if (window.frappe && typeof window.frappe.is_mobile === "function" && window.frappe.is_mobile()) {
				return true;
			}
		} catch (e) {
			// ignore
		}

		try {
			return window.matchMedia ? window.matchMedia("(max-width: 767px)").matches : window.innerWidth <= 767;
		} catch (e) {
			return false;
		}
	}

	function lt(key, fallback) {
		return dingLogin.config?.labels?.[key] || fallback || key;
	}

	function applyAuthTabsInlineStyles(hub) {
		const shellEl = document.getElementById(hub?.shellId || "frappe-login-auth-shell");
		const tabsEl = document.getElementById(hub?.tabsId || "frappe-login-sso-tabs");
		const compactMode = window.matchMedia ? window.matchMedia("(max-width: 480px)").matches : window.innerWidth <= 480;
		if (shellEl) {
			Object.assign(shellEl.style, {
				// Card already has padding; keep tabs flush under the head on redesigned login.
				padding: "12px 0 0",
			});
		}
		if (tabsEl) {
			Object.assign(tabsEl.style, {
				display: "flex",
				flexFlow: "row nowrap",
				alignItems: "center",
				justifyContent: "stretch",
				gap: "4px",
				width: "100%",
				boxSizing: "border-box",
				padding: "4px",
				marginBottom: "10px",
				borderRadius: "999px",
				background: "var(--control-bg, #f3f5f7)",
			});
		}

		document.querySelectorAll(".frappe-login-auth-shell .frappe-login-sso-tab").forEach((tabEl) => {
			const isActive = tabEl.classList.contains("is-active");
			const hasIcon = Boolean(tabEl.querySelector("img, svg"));
			const labelEl = Array.from(tabEl.children).find((el) => el.tagName === "SPAN");
			Object.assign(tabEl.style, {
				flex: "1 1 auto",
				width: "",
				minWidth: "0",
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				gap: compactMode && hasIcon ? "0" : "4px",
				padding: compactMode && hasIcon ? "8px" : "8px 10px",
				border: "none",
				borderRadius: "999px",
				background: isActive ? "var(--card-bg, #fff)" : "transparent",
				color: isActive ? "var(--text-color, #36414c)" : "var(--text-muted, #6c7680)",
				fontSize: "13px",
				lineHeight: "1",
				textAlign: "center",
				whiteSpace: "nowrap",
				userSelect: "none",
				cursor: "pointer",
				appearance: "none",
				WebkitAppearance: "none",
				boxShadow: isActive ? "0 1px 2px rgba(0, 0, 0, 0.08)" : "none",
				outline: "none",
				font: "inherit",
				overflow: "hidden",
			});
			tabEl.querySelectorAll("img, svg").forEach((iconEl) => {
				Object.assign(iconEl.style, {
					width: "1rem",
					height: "1rem",
					objectFit: "contain",
					verticalAlign: "text-bottom",
					flex: "0 0 auto",
				});
			});
			if (labelEl) {
				Object.assign(labelEl.style, {
					display: compactMode && hasIcon ? "none" : "block",
					minWidth: "0",
					maxWidth: "100%",
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					flex: "0 1 auto",
				});
			}
		});
	}

	function getLoginCardEl() {
		return (
			document.querySelector("section.for-login .login-content.page-card")
			|| document.querySelector("section.for-login .page-card")
			|| document.querySelector(".login-content.page-card")
			|| document.querySelector(".page-card")
			|| null
		);
	}

	function getLoginFormEl() {
		return (
			document.querySelector("section.for-login > .login-content.page-card > form.form-login")
			|| document.querySelector("section.for-login .login-content.page-card > form.form-signin")
			|| document.querySelector("section.for-login form.form-login")
			|| document.querySelector("form.form-login")
			|| null
		);
	}

	function getLoginHeadEl(cardEl) {
		const card = cardEl || getLoginCardEl();
		if (!card) return null;
		return card.querySelector(".page-card-head") || null;
	}

	/** Insert auth shell after page-card-head so tabs stay below logo/title on redesigned login. */
	function insertAuthShell(cardEl, shellEl) {
		if (!cardEl || !shellEl) return;
		const headEl = getLoginHeadEl(cardEl);
		if (headEl) {
			headEl.insertAdjacentElement("afterend", shellEl);
			return;
		}
		const formEl = getLoginFormEl();
		if (formEl && formEl.parentElement === cardEl) {
			cardEl.insertBefore(shellEl, formEl);
			return;
		}
		cardEl.prepend(shellEl);
	}

	/** Place SSO hub after the native login form (before sign-up message when present). */
	function insertAuthHub(cardEl, hubEl, formEl) {
		if (!cardEl || !hubEl) return;
		if (formEl && formEl.parentElement === cardEl) {
			formEl.insertAdjacentElement("afterend", hubEl);
			return;
		}
		const signupEl = cardEl.querySelector(".sign-up-message");
		if (signupEl) {
			cardEl.insertBefore(hubEl, signupEl);
			return;
		}
		cardEl.appendChild(hubEl);
	}

	function getLocalProviderMeta() {
		const logoEl = document.querySelector("section.for-login .page-card-head .app-logo")
			|| document.querySelector(".page-card-head .app-logo");
		const titleEl = document.querySelector("section.for-login .page-card-head h4")
			|| document.querySelector(".page-card-head h4");
		const rawTitle = (titleEl?.textContent || "").trim();
		let title = rawTitle
			.replace(/^Login to\s+/i, "")
			.replace(/^登录到/, "")
			.trim();

		// Redesigned login uses a generic "Sign In" title; use Website/System Settings app_name.
		if (!title || /^(sign in|登录)$/i.test(title)) {
			title = (
				dingLogin.config?.app_name
				|| window.wecom?.config?.app_name
				|| "Frappe"
			);
		}

		return {
			iconUrl: logoEl?.getAttribute("src") || "",
			title: title || "Frappe",
		};
	}

	function hasLocalLoginProvider() {
		const formEl = getLoginFormEl();
		if (!formEl) return false;

		return Boolean(
			formEl.querySelector("#login_email")
			|| formEl.querySelector("#login_password")
			|| formEl.querySelector(".btn-ldap-login")
		);
	}

	function ensureLoginSsoHub() {
		if (window.__frappe_login_auth_tabs && typeof window.__frappe_login_auth_tabs.registerProvider === "function") {
			return window.__frappe_login_auth_tabs;
		}
		if (window.__frappe_login_sso_hub && typeof window.__frappe_login_sso_hub.registerProvider === "function") {
			return window.__frappe_login_sso_hub;
		}

		const hub = {
			shellId: "frappe-login-auth-shell",
			tabsId: "frappe-login-sso-tabs",
			hubId: "frappe-login-sso-hub",
			panelsId: "frappe-login-sso-panels",
			localKey: "frappe",
			activeKey: null,
			providers: new Map(),
			ensureDom() {
				const cardEl = getLoginCardEl();
				const formEl = getLoginFormEl();
				if (!cardEl) return null;

				cardEl.classList.add("frappe-login-auth-enabled");
				if (formEl) {
					formEl.classList.add("frappe-login-local-panel");
				}

				let shellEl = document.getElementById(this.shellId);
				if (!shellEl) {
					shellEl = document.createElement("div");
					shellEl.id = this.shellId;
					shellEl.className = "frappe-login-auth-shell";

					const tabsEl = document.createElement("div");
					tabsEl.id = this.tabsId;
					tabsEl.className = "frappe-login-sso-tabs";
					shellEl.appendChild(tabsEl);

					insertAuthShell(cardEl, shellEl);
				}

				let hubEl = document.getElementById(this.hubId);
				if (!hubEl) {
					hubEl = document.createElement("div");
					hubEl.id = this.hubId;
					hubEl.className = "page-card-body frappe-login-sso-hub";

					const panelsEl = document.createElement("div");
					panelsEl.id = this.panelsId;
					panelsEl.className = "frappe-login-sso-panels";
					hubEl.appendChild(panelsEl);

					insertAuthHub(cardEl, hubEl, formEl);
				}

				applyAuthTabsInlineStyles(this);

				return {
					cardEl,
					formEl,
					shellEl,
					tabsEl: document.getElementById(this.tabsId),
					hubEl,
					panelsEl: document.getElementById(this.panelsId),
				};
			},
			createTab({ key, iconUrl, title }) {
				const tabEl = document.createElement("button");
				tabEl.type = "button";
				tabEl.className = "frappe-login-sso-tab";
				tabEl.setAttribute("aria-label", title || key);
				tabEl.setAttribute("title", title || key);
				tabEl.setAttribute("aria-pressed", "false");

				if (iconUrl) {
					const img = document.createElement("img");
					img.src = iconUrl;
					img.alt = title || key;
					tabEl.appendChild(img);
				}

				if (title) {
					const label = document.createElement("span");
					label.textContent = title;
					tabEl.appendChild(label);
				}

				tabEl.addEventListener("click", () => this.show(key));
				return tabEl;
			},
			registerLocalProvider() {
				const dom = this.ensureDom();
				if (!dom) return null;
				if (!hasLocalLoginProvider() || !dom.formEl) return null;

				const existing = this.providers.get(this.localKey);
				if (existing) return existing.panelEl;

				const localMeta = getLocalProviderMeta();
				const tabEl = this.createTab({
					key: this.localKey,
					iconUrl: localMeta.iconUrl,
					title: localMeta.title,
				});
				dom.tabsEl?.appendChild(tabEl);

				this.providers.set(this.localKey, {
					key: this.localKey,
					tabEl,
					panelEl: dom.formEl,
					priority: 0,
					isNativeForm: true,
				});
				this.updateTabsVisibility();
				this.show(this.activeKey || this.localKey);
				return dom.formEl;
			},
			updateTabsVisibility() {
				const tabsEl = document.getElementById(this.tabsId);
				const shellEl = document.getElementById(this.shellId);
				if (!tabsEl || !shellEl) return;
				const shouldShowTabs = this.providers.size > 1;
				tabsEl.style.display = shouldShowTabs ? "" : "none";
				shellEl.style.display = shouldShowTabs ? "" : "none";
			},
			show(key) {
				const dom = this.ensureDom();
				if (!dom || !this.providers.has(key)) return;

				this.activeKey = key;
				const showLocal = key === this.localKey && Boolean(this.providers.get(this.localKey)?.isNativeForm && dom.formEl);
				dom.cardEl.classList.toggle("frappe-login-auth-external", !showLocal);
				if (dom.formEl) {
					dom.formEl.style.display = showLocal ? "" : "none";
				}
				dom.hubEl.style.display = showLocal ? "none" : "block";

				for (const [providerKey, provider] of this.providers.entries()) {
					const isActive = providerKey === key;
					if (!provider.isNativeForm && provider.panelEl) {
						provider.panelEl.style.display = isActive ? "" : "none";
					}
					if (provider.tabEl) {
						provider.tabEl.classList.toggle("is-active", isActive);
						provider.tabEl.setAttribute("aria-pressed", isActive ? "true" : "false");
					}
					if (isActive && typeof provider.onShow === "function") {
						provider.onShow();
					}
				}
				applyAuthTabsInlineStyles(this);
			},
			registerProvider({ key, iconUrl, title, priority = 0, onShow = null }) {
				if (!key) return null;
				if (
					!this.providers.has(this.localKey)
					&& hasLocalLoginProvider()
					&& !shouldHideOfficialLogin()
				) {
					this.registerLocalProvider();
				}
				const dom = this.ensureDom();
				if (!dom || !dom.tabsEl || !dom.panelsEl) return null;

				if (this.providers.has(key)) {
					const existing = this.providers.get(key);
					if (existing) {
						existing.priority = priority;
						existing.onShow = onShow;
						return existing.panelEl;
					}
				}

				const tabEl = this.createTab({ key, iconUrl, title });
				const panelEl = document.createElement("div");
				panelEl.id = `frappe-login-sso-panel-${key}`;
				panelEl.style.display = "none";

				dom.tabsEl.appendChild(tabEl);
				dom.panelsEl.appendChild(panelEl);

				this.providers.set(key, {
					key,
					tabEl,
					panelEl,
					priority,
					onShow,
					isNativeForm: false,
				});
				this.updateTabsVisibility();
				applyAuthTabsInlineStyles(this);

				let nextKey = this.activeKey || (this.providers.has(this.localKey) ? this.localKey : key);
				const current = this.providers.get(nextKey);
				if (!current || priority > (current.priority || 0)) {
					nextKey = key;
				}
				if (shouldShowLocalLogin() && this.providers.has(this.localKey)) {
					nextKey = this.localKey;
				}

				this.show(nextKey);
				return panelEl;
			},
		};

		window.__frappe_login_auth_tabs = hub;
		window.__frappe_login_sso_hub = hub;
		return hub;
	}

	function getRedirectTo() {
		return getSearchParam("redirect-to") || "/app";
	}

	async function requestJson(url) {
		const r = await fetch(url, { credentials: "same-origin" });
		return r.json();
	}

	async function getLoginConfig() {
		if (dingLogin.config) return dingLogin.config;
		if (!dingLogin.configPromise) {
			dingLogin.configPromise = requestJson("/api/method/ding.api.get_login_config")
				.then((data) => data?.message || {})
				.catch(() => ({}));
		}
		dingLogin.config = await dingLogin.configPromise;
		return dingLogin.config;
	}

	function attachDdLoginMessageHandler(getGotoUrl) {
		if (window.__ding_ddlogin_message_handler_attached) return;
		window.__ding_ddlogin_message_handler_attached = true;

		window.addEventListener("message", (event) => {
			if (event.origin !== "https://login.dingtalk.com") return;
			if (!event.data || typeof event.data !== "string") return;
			const goto = getGotoUrl();
			if (!goto) return;
			window.location.href = `${goto}&loginTmpCode=${encodeURIComponent(event.data)}`;
		});
	}

	function insertDdLoginCard(panelEl, info) {
		if (!panelEl) return null;
		if (!info || !info.provider) return null;
		const mountId = `ding-ddlogin-${info.provider}`;
		if (document.getElementById(mountId)) return { mountId };
		if (document.getElementById("ding-ddlogin-card")) return { mountId };

		const card = document.createElement("div");
		card.id = "ding-ddlogin-card";
		card.className = "ding-login-addon-card";

		const wrap = document.createElement("div");
		wrap.className = "ding-ddlogin-wrap";

		const title = document.createElement("div");
		title.className = "ding-ddlogin-title";
		// title.textContent = t("Sign in with DingTalk");

		const box = document.createElement("div");
		box.className = "ding-ddlogin-box";

		const mount = document.createElement("div");
		mount.style.height = "100%";
		mount.className = "flex items-center justify-center mt-2";
		mount.id = mountId;
		box.appendChild(mount);

		wrap.appendChild(title);
		wrap.appendChild(box);

		card.appendChild(wrap);
		panelEl.appendChild(card);

		return { mountId };
	}

	function renderDdLoginIframe(mountId, gotoUrl) {
		const mount = document.getElementById(mountId);
		if (!mount) return false;
		if (mount.querySelector("iframe")) return true;

		const iframe = document.createElement("iframe");
		iframe.src = `https://login.dingtalk.com/login/qrcode.htm?goto=${encodeURIComponent(gotoUrl)}`;
		iframe.title = "DingTalk Login";
		iframe.referrerPolicy = "no-referrer";
		mount.appendChild(iframe);
		return true;
	}

	function insertDeveloperPlaceholder(panelEl, message) {
		if (!panelEl) return;
		if (document.getElementById("ding-login-dev-placeholder")) return;

		const card = document.createElement("div");
		card.id = "ding-login-dev-placeholder";
		card.className = "ding-login-qr-card";
		card.innerHTML = `
			<div class="ding-login-qr-header">
				<div>
					<div class="ding-login-qr-subtitle">${message || t("DingTalk QR login is not configured.")}</div>
				</div>
			</div>
		`;
		panelEl.appendChild(card);
	}

	function ensureDingLoginPanelWrapper(panelEl) {
		if (!panelEl) return null;

		let wrapper = document.getElementById("ding_login_panel_wrapper");
		const needsRebuild = !wrapper || !document.getElementById("ding_login_otp_view") || !document.getElementById("ding_login_qr_view");
		if (needsRebuild) {
			dingLogin.qrInitialized = false;
			dingLogin.qrInitPromise = null;
			wrapper?.remove();
			panelEl.insertAdjacentHTML(
				"beforeend",
				`
				<div id="ding_login_panel_wrapper" class="ding-login-panel">
					<div id="ding_login_mode_tabs" class="wecom-login-mode-tabs" style="display:none;" role="tablist" aria-label="${lt("ding_login", "DingTalk Login")}">
						<button type="button" role="tab" class="wecom-mode-tab is-active" data-mode="qr" aria-selected="true">
							${lt("qr_code_login", "QR Code Login")}
						</button>
						<button type="button" role="tab" class="wecom-mode-tab" data-mode="otp" aria-selected="false">
							${lt("verification_code_login", "Verification Code Login")}
						</button>
					</div>
					<div class="wecom-login-viewport">
						<div id="ding_login_qr_view" class="wecom-login-view" role="tabpanel">
							<div id="ding_login_qr_panel"></div>
						</div>
						<div id="ding_login_otp_view" class="wecom-login-view" role="tabpanel" hidden></div>
					</div>
				</div>
			`
			);
			wrapper = document.getElementById("ding_login_panel_wrapper");
		}

		return {
			wrapper,
			qrView: document.getElementById("ding_login_qr_view"),
			qrPanel: document.getElementById("ding_login_qr_panel"),
			otpView: document.getElementById("ding_login_otp_view"),
			modeTabs: document.getElementById("ding_login_mode_tabs"),
		};
	}

	function bindDingModeTabs() {
		const modeTabs = document.getElementById("ding_login_mode_tabs");
		if (!modeTabs || modeTabs.dataset.bound) return;
		modeTabs.dataset.bound = "1";
		modeTabs.querySelectorAll(".wecom-mode-tab").forEach((tab) => {
			tab.addEventListener("click", () => {
				setDingLoginMode(tab.dataset.mode || "qr");
			});
		});
	}

	async function setDingLoginMode(mode) {
		const qrView = document.getElementById("ding_login_qr_view");
		const otpView = document.getElementById("ding_login_otp_view");
		const modeTabs = document.getElementById("ding_login_mode_tabs");
		if (!qrView || !otpView) return;

		const showQr = mode === "qr";
		qrView.hidden = !showQr;
		otpView.hidden = showQr;

		if (modeTabs) {
			modeTabs.querySelectorAll(".wecom-mode-tab").forEach((tab) => {
				const isActive = tab.dataset.mode === mode;
				tab.classList.toggle("is-active", isActive);
				tab.setAttribute("aria-selected", isActive ? "true" : "false");
			});
		}

		if (showQr) {
			await ensureDingQrPanel();
		}
	}

	function makeOtpInPanel(panelEl, options = {}) {
		if (!panelEl) return;

		const dom = ensureDingLoginPanelWrapper(panelEl);
		const otpView = dom?.otpView;
		if (!dom || !otpView) return;

		const { defaultMode = "otp", showToggle = false } = options;
		const params = new URLSearchParams(location.search || "");
		const redirectTo = params.get("redirect-to") || "/app";
		const dingIcon = "/assets/ding/icons/ding.svg";

		if (!document.getElementById("ding_otp_login_form")) {
			otpView.insertAdjacentHTML(
				"beforeend",
				`
				<div id="ding_otp_login_form" class="wecom-otp-login-form ding-otp-login-form">
					<div class="page-card-body">
						<div class="wecom-otp-heading" ${showToggle ? 'style="display:none;"' : ""}>
							<img src="${dingIcon}" alt="${lt("provider_title", "DingTalk")}" class="wecom-otp-heading-icon">
							<span>${lt("login_with_verification_code", "Login with verification code")}</span>
						</div>
						<div class="form-group">
							<input type="text" id="ding_otp_email" class="form-control" required
								placeholder="${lt("email_or_mobile", "Email / Mobile")}" autocomplete="username">
						</div>
						<div class="form-group">
							<div class="wecom-otp-code-group">
								<input type="text" id="ding_otp_code" class="form-control" maxlength="6"
									pattern="[0-9]{6}" inputmode="numeric" placeholder="${lt("verification_code", "Verification Code")}">
								<button type="button" id="ding_otp_send_btn" class="wecom-otp-send-btn">${lt("send_code", "Send Code")}</button>
							</div>
						</div>
					</div>
					<div class="page-card-actions">
						<button type="button" id="ding_otp_login_btn" class="btn btn-sm btn-primary btn-block btn-login">
							<span class="wecom-otp-login-btn-content">
								<img src="${dingIcon}" alt="${lt("provider_title", "DingTalk")}" class="wecom-otp-login-btn-icon">
								<span>${lt("login", "Login")}</span>
							</span>
						</button>
					</div>
					<div class="wecom-otp-hint">${lt("otp_hint", "Verification code will be sent to your DingTalk app.")}</div>
					<div id="ding_otp_status" class="wecom-otp-status" style="display:none;"></div>
				</div>
			`
			);
		}

		if (dom.modeTabs) {
			dom.modeTabs.style.display = showToggle ? "flex" : "none";
			bindDingModeTabs();
		}

		void setDingLoginMode(defaultMode);

		const emailInput = document.getElementById("ding_otp_email");
		const codeInput = document.getElementById("ding_otp_code");
		const sendBtn = document.getElementById("ding_otp_send_btn");
		const loginBtn = document.getElementById("ding_otp_login_btn");
		const statusEl = document.getElementById("ding_otp_status");
		const codeGroup = otpView.querySelector(".wecom-otp-code-group");
		const otpHeading = otpView.querySelector(".wecom-otp-heading");
		const loginBtnContent = loginBtn?.querySelector(".wecom-otp-login-btn-content");
		const loginBtnIcon = loginBtn?.querySelector(".wecom-otp-login-btn-icon");
		if (!emailInput || !codeInput || !sendBtn || !loginBtn || sendBtn.dataset.bound) return;
		sendBtn.dataset.bound = "1";
		let countdown = 0;
		let countdownTimer = null;

		function applyOtpInlineStyles() {
			if (otpHeading) {
				Object.assign(otpHeading.style, {
					display: showToggle ? "none" : "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: "8px",
					marginBottom: "14px",
					color: "var(--text-color, #36414c)",
					fontSize: "14px",
					fontWeight: "600",
				});
			}

			const headingIcon = otpHeading?.querySelector(".wecom-otp-heading-icon");
			if (headingIcon) {
				Object.assign(headingIcon.style, {
					width: "18px",
					height: "18px",
					flex: "0 0 auto",
				});
			}

			if (codeGroup) {
				Object.assign(codeGroup.style, {
					display: "flex",
					alignItems: "center",
					gap: "8px",
					padding: "6px 8px 6px 12px",
					borderRadius: "8px",
					background: "var(--control-bg, #f3f5f7)",
				});
			}

			Object.assign(codeInput.style, {
				flex: "1 1 auto",
				width: "100%",
				marginBottom: "0",
				padding: "4px 0",
				border: "0",
				borderRadius: "0",
				background: "transparent",
				boxShadow: "none",
			});

			Object.assign(sendBtn.style, {
				flex: "0 0 auto",
				height: "32px",
				minWidth: "96px",
				padding: "0 12px",
				border: "0",
				borderRadius: "999px",
				background: "var(--card-bg, #fff)",
				color: "var(--text-muted, #6c7680)",
				fontSize: "12px",
				fontWeight: "600",
				lineHeight: "1",
				whiteSpace: "nowrap",
				boxShadow: "inset 0 0 0 1px var(--border-color, #d1d8dd)",
			});

			if (loginBtnContent) {
				Object.assign(loginBtnContent.style, {
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					gap: "8px",
				});
			}

			if (loginBtnIcon) {
				Object.assign(loginBtnIcon.style, {
					width: "16px",
					height: "16px",
					flex: "0 0 auto",
				});
			}
		}

		function syncSendButtonStyle() {
			if (sendBtn.disabled) {
				sendBtn.style.background = "var(--card-bg, #fff)";
				sendBtn.style.color = "var(--text-light, #8d99a6)";
				sendBtn.style.opacity = "0.7";
				sendBtn.style.cursor = "not-allowed";
				return;
			}

			sendBtn.style.background = "var(--card-bg, #fff)";
			sendBtn.style.color = "var(--text-muted, #6c7680)";
			sendBtn.style.opacity = "1";
			sendBtn.style.cursor = "pointer";
		}

		function showStatus(message, type) {
			if (!statusEl) return;
			statusEl.textContent = message;
			statusEl.className = "wecom-otp-status" + (type ? ` is-${type}` : "");
			statusEl.style.display = message ? "" : "none";
		}

		function startCountdown(seconds) {
			countdown = seconds;
			sendBtn.disabled = true;
			syncSendButtonStyle();
			if (countdownTimer) clearInterval(countdownTimer);
			sendBtn.textContent = `${countdown}s`;
			countdownTimer = setInterval(() => {
				countdown -= 1;
				if (countdown <= 0) {
					clearInterval(countdownTimer);
					countdownTimer = null;
					sendBtn.disabled = false;
					sendBtn.textContent = lt("send_code", "Send Code");
					syncSendButtonStyle();
					return;
				}
				sendBtn.textContent = `${countdown}s`;
			}, 1000);
		}

		applyOtpInlineStyles();
		syncSendButtonStyle();

		sendBtn.addEventListener("click", () => {
			const email = (emailInput.value || "").trim();
			if (!email) {
				showStatus(lt("email_or_mobile_required", "Email or mobile number is required"), "error");
				emailInput.focus();
				return;
			}
			showStatus("", "");
			sendBtn.disabled = true;
			syncSendButtonStyle();
			frappe.call({
				method: "ding.ding_login_otp.send_ding_login_otp",
				type: "POST",
				args: { email },
				callback(r) {
					if (r.message && r.message.message) {
						showStatus(r.message.message, "success");
						startCountdown(60);
						codeInput.focus();
					} else {
						sendBtn.disabled = false;
						syncSendButtonStyle();
					}
				},
				error() {
					sendBtn.disabled = false;
					syncSendButtonStyle();
				},
			});
		});

		loginBtn.addEventListener("click", () => {
			const email = (emailInput.value || "").trim();
			const otp = (codeInput.value || "").trim();
			if (!email || !otp) {
				showStatus(
					lt(
						"email_or_mobile_and_verification_code_required",
						"Email or mobile number and verification code are required"
					),
					"error"
				);
				return;
			}

			showStatus("", "");
			loginBtn.disabled = true;
			frappe.call({
				method: "ding.ding_login_otp.verify_ding_login_otp",
				type: "POST",
				args: { email, otp, redirect: redirectTo },
				callback(r) {
					if (r.message && r.message.redirect_to) {
						window.location.href = r.message.redirect_to;
					} else {
						loginBtn.disabled = false;
					}
				},
				error() {
					loginBtn.disabled = false;
				},
			});
		});

		codeInput.addEventListener("keydown", (e) => {
			if (e.key === "Enter") {
				e.preventDefault();
				loginBtn.click();
			}
		});
	}

	async function tryInitQrConnectLogin(getPanelEl, redirectTo, loginDebug) {
		try {
			const url = `/api/method/ding.api.get_qrconnect_login_info?redirect=${encodeURIComponent(redirectTo)}`;
			const data = await requestJson(url);
			const info = data && data.message;
			if (!info) return false;
			const developerMode = Boolean(loginDebug || info.developer_mode || frappe.boot?.developer_mode);
			if (!info.enabled && !developerMode) return false;
			if (!info.provider || !info.goto) {
				if (developerMode) {
					insertDeveloperPlaceholder(
						typeof getPanelEl === "function" ? getPanelEl() : null,
						info.message || t("DingTalk QR login is not configured.")
					);
					return true;
				}
				return false;
			}

			const panelEl = typeof getPanelEl === "function" ? getPanelEl() : null;
			const insertResult = insertDdLoginCard(panelEl, info);
			if (!insertResult || !insertResult.mountId) return false;

			attachDdLoginMessageHandler(() => info.goto);

			if (typeof window.DDLogin === "function") {
				try {
					window.DDLogin({
						id: insertResult.mountId,
						goto: encodeURIComponent(info.goto),
						style: "border:none;background-color:transparent;",
						width: "320",
						height: "370",
					});
				} catch (e) {
					// ignore
				}
			}

			const mount = document.getElementById(insertResult.mountId);
			const hasIframe = mount ? Boolean(mount.querySelector("iframe")) : false;
			if (!hasIframe) {
				if (!renderDdLoginIframe(insertResult.mountId, info.goto)) return false;
			}

			return true;
		} catch (e) {
			return false;
		}
	}

	async function ensureDingQrPanel() {
		if (dingLogin.qrInitialized) return true;
		if (dingLogin.qrInitPromise) return dingLogin.qrInitPromise;

		dingLogin.qrInitPromise = (async () => {
			const qrPanel = document.getElementById("ding_login_qr_panel");
			if (!qrPanel) return false;

			const cfg = dingLogin.config || {};
			const developerMode = Boolean(dingLogin.loginDebug || cfg.developer_mode || frappe.boot?.developer_mode);
			const didInitQrConnect = await tryInitQrConnectLogin(() => qrPanel, dingLogin.redirectTo, dingLogin.loginDebug);
			if (didInitQrConnect) {
				dingLogin.qrInitialized = true;
				return true;
			}

			try {
				const data = await requestJson(
					`/api/method/ding.api.get_passwordless_login_info?redirect=${encodeURIComponent(dingLogin.redirectTo)}`
				);
				if (!data || !data.message) {
					if (developerMode) {
						insertDeveloperPlaceholder(qrPanel, lt("qr_not_configured", "DingTalk QR login is not configured."));
					}
					return false;
				}
				if (!data.message.enabled && !developerMode) return false;
				if (!data.message.qr_svg_base64) {
					if (developerMode) {
						insertDeveloperPlaceholder(
							qrPanel,
							data.message.message || lt("qr_not_configured", "DingTalk QR login is not configured.")
						);
					}
					return false;
				}
				insertQrCard(qrPanel, data.message);
				dingLogin.qrInitialized = true;
				return true;
			} catch (e) {
				if (developerMode) {
					insertDeveloperPlaceholder(qrPanel, t("Login failed."));
				}
				return false;
			} finally {
				dingLogin.qrInitPromise = null;
			}
		})();

		return dingLogin.qrInitPromise;
	}

	function insertQrCard(panelEl, info) {
		if (!panelEl) return;
		if (document.getElementById("ding-login-qr-card")) return;

		const card = document.createElement("div");
		card.id = "ding-login-qr-card";
		card.className = "ding-login-qr-card";

		const header = document.createElement("div");
		header.className = "ding-login-qr-header";

		const titleWrap = document.createElement("div");

		const title = document.createElement("div");
		title.className = "ding-login-qr-title";
		// title.textContent = t("Sign in with DingTalk");

		const subtitle = document.createElement("div");
		subtitle.className = "ding-login-qr-subtitle";
		subtitle.textContent = t("Scan with DingTalk to sign in.");

		titleWrap.appendChild(title);
		titleWrap.appendChild(subtitle);
		header.appendChild(titleWrap);

		const img = document.createElement("img");
		img.alt = "DingTalk QR";
		img.src = `data:image/svg+xml;base64,${info.qr_svg_base64}`;

		const qrBox = document.createElement("div");
		qrBox.className = "ding-login-qr-box";
		qrBox.appendChild(img);

		const actions = document.createElement("div");
		actions.className = "ding-login-qr-actions";

		const openLink = document.createElement("a");
		openLink.href = info.login_url;
		openLink.target = "_blank";
		openLink.rel = "noopener noreferrer";
		openLink.className = "btn btn-sm btn-primary";
		openLink.textContent = t("Open DingTalk login");
		actions.appendChild(openLink);

		card.appendChild(header);
		card.appendChild(qrBox);
		card.appendChild(actions);
		panelEl.appendChild(card);
	}

	async function run() {
		if (!isLoginPage()) return;
		dingLogin.loginDebug = isTruthyParam("login_debug");
		dingLogin.redirectTo = getRedirectTo();
		dingLogin.config = await getLoginConfig();

		const cfg = dingLogin.config || {};
		const developerMode = Boolean(dingLogin.loginDebug || cfg.developer_mode || frappe.boot?.developer_mode);
		const hasOtp = Boolean(cfg.enable_otp_login || developerMode);
		const hasQr = !isWeChatUa() && !isMobileDevice();
		const shouldRenderProvider = Boolean(cfg.enabled_passwordless_login || hasOtp || developerMode);
		if (!shouldRenderProvider) {
			return;
		}

		let panelEl = null;
		const hub = ensureLoginSsoHub();
		const dingPriority = isWeChatUa() ? 10 : 30;

		function ensureDingPanel() {
			if (panelEl) return panelEl;
			panelEl = hub.registerProvider({
				key: "ding",
				iconUrl: "/assets/ding/icons/ding.svg",
				title: lt("provider_title", "DingTalk"),
				priority: dingPriority,
				onShow: () => {
					const modeTabs = document.getElementById("ding_login_mode_tabs");
					const activeMode = modeTabs?.querySelector(".wecom-mode-tab.is-active")?.dataset.mode || "qr";
					if (hasQr && activeMode === "qr") {
						void ensureDingQrPanel();
					}
				},
			});
			return panelEl;
		}

		const panel = ensureDingPanel();
		if (!panel) return;

		if (!hasQr && !hasOtp) {
			if (developerMode) {
				const dom = ensureDingLoginPanelWrapper(panel);
				insertDeveloperPlaceholder(dom?.qrPanel || panel, lt("qr_not_configured", "DingTalk QR login is not configured."));
			}
			return;
		}

		const dom = ensureDingLoginPanelWrapper(panel);
		if (!dom) return;

		if (hasOtp) {
			makeOtpInPanel(panel, {
				defaultMode: hasQr ? "qr" : "otp",
				showToggle: hasQr,
			});
		} else {
			dom.modeTabs && (dom.modeTabs.style.display = "none");
			void setDingLoginMode("qr");
		}

		if (hasQr && !hasOtp) {
			void ensureDingQrPanel();
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", run);
	} else {
		run();
	}
})();
